import React, { useEffect, useRef } from "react";
import backgroundOnLoad from "../../images/bak3.webp";
import MyVideo from "../../yellow.mp4";
import { DownArrow } from "./DownArrow";
import Typed from "typed.js";
import "./home.css";

export const Home = () => {
  const element = useRef(null);
  const typed = useRef(null);
  useEffect(() => {
    const options = {
      strings: [
        "I'm a <b style='color: gold'>Junior FRONT END DEVELOPER.</b>",
        "I'm also expert in <b style='color:rgb(255, 123, 123)'>UI/UX</b> design.",
        "I create <b style='color: gold'>software and design websites</b>.",
        "Feel free to contact me",
      ],
      typeSpeed: 100,
      backSpeed: 50,
      loop: true,
    };

    // element Ref refers to the <span> rendered below
    typed.current = new Typed(element.current, options);

    return () => {
      // destroying Typed instance during cleanup to prevent memory leaks
      typed.current.destroy();
    };
  }, []);
  return (
    <div className="video-wrapper">
      <video autoPlay muted loop playsInline poster={backgroundOnLoad}>
        <source src={MyVideo} type="video/mp4"></source>
      </video>

      {/* <!-- This will be positioned on top of our video background --> */}
      <div className="header">
        <div className="myName-h1" data-aos="zoom-in">
          <h1>Md Niamul Hakim Shawn</h1>
          <div className="home-first-p">
            <p>
              <span ref={element} className="type-span"></span>
            </p>
          </div>
          <div className="margin-contact-btn">
            <a
              className="my-home-contact-btn"
              href="https://www.linkedin.com/in/md-niamul-hakim-936948239"
              target="_blank"
              rel="noreferrer"
            >
              Contact me
            </a>
          </div>
        </div>
      </div>
        <DownArrow />
    </div>
  );
};
